import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1818_13652)">
        <path d="M1 8L8 11.5L15 8M1 11.5L8 15L15 11.5M1 4.5L8 8L15 4.5L8 1L1 4.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_1818_13652">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;